import React from 'react';
import Dialog from '@material-ui/core/Dialog';

import UserProfileCard from './UserProfileCard';


export default function ShowUserProfileDialog({user,open,onModalClose}) {
  return (

        <Dialog open={open} onClose={onModalClose}>
   
          <UserProfileCard user = {user} headerStyle = "bg-gradient-primary" onModalClose={onModalClose} closeButtonState={true} />
         
      
        </Dialog>
     
      
  );
}
